import { version } from '../../../package.json';

const header = {
  namespaced: true,
  state: {
    dropdownActions: [],
    appVersion: version,
  },
  mutations: {
    setDropdownActions(state, { actions }) {
      state.dropdownActions = actions;
    },
    setAppVersion(state, { version }) {
      state.appVersion = version;
    },
  },
};

export default header;
